import { AfterViewInit, Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PushNotificationRecipient } from '../../../services/pcode/notification/notification.models';
import { NotificationService } from '../../../services/pcode/notification/notification.service';

@Component({
    selector: 'pcode-send-notification-dialog',
    templateUrl: './send-notification-dialog.component.html',
    styleUrls: ['./send-notification-dialog.component.scss'],
    standalone: false
})
export class SendNotificationDialogComponent implements AfterViewInit
{
	// send message form
	_form: UntypedFormGroup = this.fb.group(
		{
			userId: [null, [Validators.required]],
			message: [null, [Validators.required]]
		}
	);
	get userId() { return this._form.get('userId'); }
	get message() { return this._form.get('message'); }

	_pushNotificationsRecipients: Array<PushNotificationRecipient>;

	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<SendNotificationDialogComponent>,
			private fb: UntypedFormBuilder,
			private notificationService: NotificationService
		)
	{
	}

	// after view init
	ngAfterViewInit()
	{
		// getting recipients
		this.notificationService.getPushNotificationsRecipients().subscribe(result =>
		{
			this._pushNotificationsRecipients = result;
			this._form.reset();
		});
	}

	// send notification
	sendNotification()
	{
		this._form.markAllAsTouched();

		if (this._form.valid)
		{
			this.notificationService.sendPushMessage(this._form.value)
				.subscribe(
					() =>
					{
						this.dialogRef.close({ success: true })
					},
					error =>
					{
						this.dialogRef.close({ success: false, error: error })
					}
				);
		}
	}

	// close dialog
	closeDialog()
	{
		this.dialogRef.close({ created: false });
	}
}
